import React from 'react';
import 'assets/scss/modules/progress.scss';
import CheckIcon from 'assets/img/progress/check.svg';
import CompletedIcon from 'assets/img/progress/active.svg';
import InProgressIcon from 'assets/img/progress/inactive.svg';
import classNames from 'classnames';
import { Props } from './progress.type';

const Text = ({
  icon,
  label,
  size = 24,
  className = ' '
}: {
  icon: string;
  label: string;
  size?: number;
  className?: string;
}) => {
  return (
    <div className={classNames('d-flex gap-2 align-items-center', className)}>
      <img src={icon} width={size} />
      <span>{label}</span>
    </div>
  );
};

function Progress({ steps }: Props) {
  return (
    <div className="status_stepper py-4">
      <div className="status_stepper__container d-flex">
        {steps.map(({ step, stepIndex, child, percentage }, index) => {
          return (
            <div
              className={classNames('status_stepper__container__step', {
                start: index === 0,
                end: steps.length - 1 === index
              })}
              key={stepIndex}
              style={{
                background: `linear-gradient(to right, transparent ${percentage}%, #d3d3d3 ${percentage}%)`
              }}
            >
              <Text
                icon={CheckIcon}
                label={step}
                className="text-secondary-dark"
              />
              <div className="add-on py-2">
                {child.map(({ step: childStep, done }, idx) => (
                  <Text
                    key={idx}
                    icon={done ? CompletedIcon : InProgressIcon}
                    label={childStep}
                    size={18}
                    className="text-body-highlight"
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Progress;
